import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

const EditStreamDirective = angularDirectiveToReact('editStream', { streamId: '<' });

export function EditStreamComponent() {
    useLoadEditorDependencies();
    const [key, params] = useAngularToReactRoute<{ streamId: string }>();

    return <EditStreamDirective key={key} {...params} />;
}
